import React from 'react';
import { AgentMarkdown } from './conversationPrimitives';
import { renderChatMarkdown } from './chatMarkdown';

export const ChatMessageContent = ({ message, onClick }: { message: string; onClick?: React.MouseEventHandler<HTMLDivElement> }) => (
    <AgentMarkdown onClick={onClick} dangerouslySetInnerHTML={{ __html: renderChatMarkdown(message) }} />
);
